import winston, { format } from 'winston';
import ecsFormat from '@elastic/ecs-winston-format';
import ECSLogger from '@my-account/ecs-logger';
import filterLogs from './log-format/filterLogs';
import logBaseFields from './logBaseFields';

const winstonLoggerConfig = winston.createLogger({
  level: 'warn',
  format: format.combine(
    format.json(),
    format.errors({ stack: true }),
    filterLogs(['/health', '/favicon.ico']),
    ecsFormat({ convertReqRes: true }),
  ),
  transports: [new winston.transports.Console()],
});
const ecsLogger = new ECSLogger<ExtraFields>(winstonLoggerConfig);
ecsLogger.setBaseFields(logBaseFields);

interface ExtraFields {
  productId?: string;
  site?: string;
  skus?: Array<string>;
}
export default ecsLogger;
